<template>
    <icon-base v-bind="$props">
        <path d="M12 5l0 14"></path>
        <path d="M5 12l14 0"></path>
    </icon-base>
</template>

<script setup>
import IconBase, { iconProps } from './IconBase.vue'

defineProps(iconProps)
</script>
